module.exports = __webpack_public_path__ + "static/media/Lateral_End Stage_Z1.a9a92ea5.png";